var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import History from 'helpers/History';
import { T } from 'helpers/i18n';
import { Button, FieldType, Input } from 'elements';
let UserLogin = class UserLogin extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            client: '',
            username: '',
            password: ''
        };
        this.handleChange = (event) => {
            // console.log('handleChange - event.target.name', event.target.name)
            this.setState({ [event.target.name]: event.target.value });
        };
        this.handleSubmit = () => {
            this.props.store.users.login(this.state).then(() => {
                History.replace('/');
                History.push('/operationlines');
            });
        };
        this.handleHelp = () => {
            /* History.replace('/recovery')*/
        };
    }
    render() {
        const { client, username, password } = this.state;
        return (React.createElement(Wrapper, null,
            React.createElement(InsideWrapper, null,
                React.createElement(StyledInput, { label: T('client'), name: 'client', value: client, type: FieldType.Text, onChange: this.handleChange }),
                React.createElement(StyledInput, { label: T('username'), name: 'username', value: username, type: FieldType.Text, onChange: this.handleChange }),
                React.createElement(StyledInput, { label: T('password'), name: 'password', value: password, type: FieldType.Password, onChange: this.handleChange, onSubmit: this.handleSubmit })),
            React.createElement(ButtonWrapper, null,
                React.createElement(RecoveryButton, { onClick: this.handleHelp }, T('help')),
                React.createElement(LoginButton, { primary: true, loading: 'post@login', onClick: this.handleSubmit }, T('logIn')))));
    }
};
UserLogin = __decorate([
    inject('store'),
    observer
], UserLogin);
export default UserLogin;
const Wrapper = cxs('div')({});
const InsideWrapper = cxs('div')({
    padding: Theme.size.space[4]
});
const ButtonWrapper = cxs('div')({
    borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    marginTop: Theme.size.space[1]
});
const StyledInput = cxs(Input)({
    padding: Theme.size.space[1]
});
const RecoveryButton = cxs(Button)({
    width: '50%',
    borderRight: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    padding: Theme.size.space[2]
});
const LoginButton = cxs(Button)({
    width: '50%',
    padding: Theme.size.space[2]
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Users/containers/UserLogin.tsx
// module id = 577
// module chunks = 0